import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmationModal.module.scss';
const ConfirmModal = ({ text, onClick }) => {
    const { t } = useTranslation();
    return (_jsxs(Modal, Object.assign({ className: styles.element, background: true, closeModal: onClick }, { children: [_jsx(Heading, { className: 'mb-xxlarge', title: text }), _jsx(Button, { size: '100', text: t('ok'), onClick: onClick })] })));
};
export default ConfirmModal;
